import { useMemo } from 'react';
import { CategoryInterface, ProductInterface } from '../../../services/exports/Interfaces';
import MultiSelectProduct from './MultiSelectProduct';
import SingleSelectProduct from './SingleSelectProduct';
import { WithActualPrice } from '../../../providers/MenuProvider';
import { CategoryType } from '../../../services/exports/Constants';

interface Props {
  product: WithActualPrice<ProductInterface>;
  category?: CategoryInterface<WithActualPrice<ProductInterface>>;
  className?: string;
  discount?: string | number;
  toggleProduct?: () => void;
}

export default function ProductItem(props: Props) {
  const { product, category, className, discount, toggleProduct } = props;

  const renderMultiSelectProduct = useMemo(
    () => (
      <MultiSelectProduct product={product} discount={discount} className={className} toggleProduct={toggleProduct} />
    ),
    [product, className, toggleProduct],
  );

  const renderSingleSelectProduct = useMemo(
    () => <SingleSelectProduct product={product} className={className} toggleProduct={toggleProduct} />,
    [product, className, toggleProduct],
  );

  if (!category || category?.id > 0 || category.type === CategoryType.Bogo) {
    return renderMultiSelectProduct;
  }

  return renderSingleSelectProduct;
}
